import { useState } from 'react'

import { formatCost, formatNumbers } from 'utils'
import { ModalRemoveFromCart } from '@/components/modals'
import { useCartItem } from '@/context/CartItemContext'
import { ProductsAddOn } from '@/lib/types/products'

type Props = {
	addOns: ProductsAddOn
	readOnly?: boolean
}

export default function CartAdditionalCharges({ addOns, readOnly = false }: Props) {
	const { cartItem, cartItemQuantity } = useCartItem()

	const [showRemoveFromCartModal, setShowRemoveFromCartModal] = useState(false)

	return (
		<>
			<div className="tableRowCharge">
				<div className="flex items-center text-sm flex-wrap">
					<span>{addOns.title}</span>
					<span className="bullet"></span>
					{formatNumbers(cartItemQuantity)} @ {formatCost(addOns.price)} each{' '}
					{addOns.setupFee && `/ + $${addOns.setupFee} per size`}
					{!readOnly && (
						<>
							<span className="bullet"></span>
							<button
								className="hyperlink"
								type="button"
								onClick={() => setShowRemoveFromCartModal(true)}
							>
								Remove
							</button>
						</>
					)}
				</div>
				<span className="font-medium">{formatCost(addOns.totalPrice)}</span>
			</div>
			<ModalRemoveFromCart
				show={showRemoveFromCartModal}
				setShow={setShowRemoveFromCartModal}
				itemStyle={cartItem.itemStyles[0]}
				addOns={addOns}
				cartItem={cartItem}
				isAdditionalCharge={true}
			/>
		</>
	)
}
